var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconCloseRound-24px",
    clipPath: "url(#clip0_6695_7411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.92849 4.92893C1.02526 8.83216 1.02526 15.1678 4.92849 19.0711C8.83172 22.9743 15.1674 22.9743 19.0706 19.0711C22.9739 15.1678 22.9739 8.83216 19.0706 4.92893C15.1674 1.0257 8.83172 1.0257 4.92849 4.92893ZM16.8886 7.81802C17.0839 8.01328 17.0839 8.32986 16.8886 8.52513L13.4138 12L16.8886 15.4749C17.0839 15.6701 17.0839 15.9867 16.8886 16.182L16.1815 16.8891C15.9863 17.0843 15.6697 17.0843 15.4744 16.8891L11.9996 13.4142L8.52468 16.8891C8.32942 17.0843 8.01284 17.0843 7.81758 16.8891L7.11047 16.182C6.91521 15.9867 6.91521 15.6701 7.11047 15.4749L10.5853 12L7.11047 8.52513C6.91521 8.32986 6.91521 8.01328 7.11047 7.81802L7.81758 7.11091C8.01284 6.91565 8.32942 6.91565 8.52468 7.11091L11.9996 10.5858L15.4744 7.11091C15.6697 6.91565 15.9863 6.91565 16.1815 7.11091L16.8886 7.81802Z",
    fill: "#E10D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6695_7411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2de00779dd1bd9146f6f1c22c557f625.svg";
export { ForwardRef as ReactComponent };